import React, { FunctionComponent } from 'react';
import { Box, Flex } from '@rebass/emotion';
import { RouteComponentProps } from 'react-router-dom';
import { ProductFinderContentPageQuery_productFinderContentPage_sections_ctaButtons as CtaButtonInterface } from '@app/hooks/useContentPage/__generated__/ProductFinderContentPageQuery';
import { Wrapper, CtaButton, BodyContent } from './FeaturedProducts.styles';
import ProductTile from '../ProductTile';
import { getProductsBySku_getProducts_result_items as Product } from './__generated__/getProductsBySku';
import ProductPlaceholders from '../ProductPlaceholders';

export interface FeaturedProductsProps extends RouteComponentProps {
  content: string;
  ctaButtons: CtaButtonInterface[];
  products: Product[];
  loading: boolean;
  skus: string[];
}

const FeaturedProducts: FunctionComponent<FeaturedProductsProps> = ({
  content,
  ctaButtons,
  products,
  loading,
}) => {
  const hasProducts = products && products.length > 0;

  if (loading) {
    return <ProductPlaceholders count={4} />;
  }

  return hasProducts ? (
    <Box>
      <Wrapper>
        {content && (
          <BodyContent
            data-testid="body-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}

        {ctaButtons && (
          <Flex justifyContent="center">
            {ctaButtons.map(({ text, link }, index) => (
              <CtaButton
                data-testid={`cta-button-${index}`}
                key={index}
                href={link}
              >
                {text}
              </CtaButton>
            ))}
          </Flex>
        )}
      </Wrapper>

      <Flex justifyContent={'space-between'} flexWrap={'wrap'}>
        {!loading &&
          products.map((product, index) => (
            <Box
              data-testid="featured-product"
              key={index}
              width={[1, 1 / 2, 1 / 3, 1 / 4]}
              px={[0, 2]}
              py={3}
            >
              <ProductTile product={product} />
            </Box>
          ))}
      </Flex>
    </Box>
  ) : null;
};

export default FeaturedProducts;
